// extracted by mini-css-extract-plugin
module.exports = {"pendingNewVersion":"wnkoW","messageEnter":"yWsUZ","messageEnterActive":"_4UjLU","messageLeave":"_0pDxZ","messageLeaveActive":"XKY0p"};